import PlaylistSearchTileV3 from './PlaylistSearchTileV3'

export default PlaylistSearchTileV3
